import React, { Fragment, useEffect, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Decimal from 'decimal.js';
import { Table, Button } from 'antd';
import Helpers from '@Apis/helpers';
import H3FormInput from '@Uilib/h3FormInput';
import MOActions from '@Actions/moActions';
import RawMaterialBatchSelector from '@Components/Production/ManufacturingOrders/ViewManufacturingOrder/Drawer/UpdateRawMaterial/RawMaterialBatchSelector/index.jsx';
import { QUANTITY } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import { v4 as uuidv4 } from 'uuid';
import jobWorkActions from '@Actions/production/jobWorkActions';
import './style.scss';
import ProductCategoryLabel from '../../../../Common/ProductCategoryLabel';

/**
 *
 */
function IssueRawMaterial ({
  user, items, createMOAdjustmentLoading, createMOAdjustment, callback,
 selectedJobWork, rmIssueType, processJwMaterialLoading, processJwMaterial }) {

  const [rawMaterials, setRawMaterials] = useState([]);
  const [allStock, setAllStock] = useState(true);

  const updateAllStock = (value, key, quantity) => {
    const copyData = JSON.parse(JSON.stringify(rawMaterials));
    const updatedData = copyData.map((item) => {
      if (item.key !== key) return item;
      let productBatches = getBatches(item?.product_batches, Math.min(quantity, Helpers.getValueTotalInObject(item?.product_batches, 'available_qty')), value);
      return {
        ...item,
        product_batches: productBatches,
        good_stock_only: value,
      };
    });
    setRawMaterials(updatedData);
  }
  const rawMaterialColumns = [
    {
      title: 'Product',
      width: '250px',
      render: (item) => (
        <Fragment>
          <Link to={`/inventory/product/view/${item.product_sku_id}`} target="_blank">
            {`#${item?.internal_sku_code}`}
          </Link>
          {` ${item?.ref_product_code ? `${item?.ref_product_code} - ` : ''} ${item?.product_sku_name}`}
          {item?.product_category_info?.category_path?.length > 0 && (
            <ProductCategoryLabel
              categoryPath={item?.product_category_info?.category_path}
              categoryName={item?.product_category_info?.category_path?.at(-1)}
              containerStyle={{
                width: 'fit-content',
              }}
            />
          )}
        </Fragment>
      ),
    },
    {
      title: 'Required Quantity',
      render: (record) => (
        <Fragment>
          {QUANTITY(record?.required_quantity, record?.uom_info?.precision)}
          &nbsp;{record?.uom_info?.uqc?.toProperCase()}
        </Fragment>
      ),
    },
    {
      title: 'Pending',
      render: (item) => (
        <Fragment>
          {QUANTITY(item?.pending_quantity || 0, item?.uom_info?.precision)}&nbsp;{item?.uom_info?.uqc?.toProperCase()}
        </Fragment>
      ),
    },
    {
      title: 'Available Stock',
      render: (item) => `${QUANTITY(Helpers.getValueTotalInObject(item?.product_batches?.filter((i) => i?.batch_in_use && (item?.good_stock_only ? !i?.is_rejected_batch : true)), 'available_qty'), item?.uom_info?.precision)} ${item?.uom_info?.uqc?.toProperCase()}`,
    },
    {
      title: 'Quantity',
      width: '180px',
      render: (record) => {
        return (
          <Fragment>
            {!record?.product_batches?.map((item) => item.available_qty > 0)?.length > 0 ? <div className="input-error">OUT OF STOCK</div> : (
              <Fragment>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <H3FormInput
                    value={record.quantity}
                    type="number"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput"
                    name="quantity is more than available quantity"
                    onChange={(e) => {
                      let remainingQty = Number(e.target.value);
                      const copyData = JSON.parse(JSON.stringify(rawMaterials));
                      for(let i = 0; i < copyData?.length; i++) {
                        if(copyData?.[i]?.key === record?.key) {
                          const batches = copyData?.[i]?.product_batches;
                          for (let i = 0; i < batches?.length; i++) {
                            batches[i].consumed_qty = 0;
                          }
                          for (let i = 0; i < batches?.length; i++) {
                            if (batches[i]?.batch_in_use) {
                              const consumedQty = new Decimal(batches[i].consumed_qty || 0);
                              const availableQty = new Decimal(batches[i]?.available_qty || 0);
                              let remaining = new Decimal(remainingQty);

                              if (record?.good_stock_only && batches[i]?.is_rejected_batch) {
                                continue;
                              }

                              if (remaining.gt(0) && consumedQty.lt(availableQty)) {
                                const assignedQty = Decimal.min(availableQty, remaining);
                                batches[i].consumed_qty = assignedQty.toNumber();
                                remainingQty = remaining.minus(assignedQty).toNumber();
                              } else {
                                batches[i].consumed_qty = 0;
                                remainingQty = remaining.minus(0).toNumber();
                              }
                            }
                          }
                          copyData[i].product_batches = batches;
                          copyData[i].quantity = e.target.value;
                          break;
                        }
                      }
                      setRawMaterials(copyData);
                    }}
                  />
                  <div style={{ marginLeft: '6px' }}>
                    {record?.uom_info?.uqc?.toProperCase()}
                  </div>
                </div>
                {Number(record?.quantity) > Helpers.getValueTotalInObject(record?.product_batches?.filter((batch) => batch?.batch_in_use), 'available_qty') ? <H3Text className="input-error" text="Sufficient stock is not available" /> : ''}
              </Fragment>
            )}
          </Fragment>
        );
      },
    },
  ];

  /**
   * This function calculates and returns an array of batches based on the input quantity.
   * Each batch object in the array will have a unique key, consumed quantity, and a flag indicating it is in use.
   * The consumed quantity is determined based on the available quantity of the batch and the remaining quantity needed.
   * @param {Array} inputBatches - The array of input batches.
   * @param {number} quantity - The quantity needed.
   * @returns {Array} - The array of batches with consumed quantity.
   */
  // const getBatches = (inputBatches, quantity) => {
  //   let remainingQty = quantity;
  //   if (!inputBatches?.length) return [];
  //   const batches = JSON.parse(JSON.stringify(inputBatches?.filter((item) => item.is_usable)));
  //   for (let i = 0; i < batches?.length; i++) {
  //     batches[i].key = uuidv4();
  //     batches[i].consumed_qty = 0;
  //     batches[i].batch_in_use = true;
  //   }
  //   for (let i = 0; i < batches?.length; i++) {
  //     if (batches[i]?.batch_in_use) {
  //       if (remainingQty > 0 && Number(batches[i].consumed_qty || '0') < batches?.[i]?.available_qty) {
  //         batches[i].consumed_qty = batches?.[i]?.available_qty > remainingQty ? remainingQty : batches?.[i]?.available_qty;
  //         remainingQty -= batches[i].consumed_qty;
  //       } else {
  //         batches[i].consumed_qty = 0;
  //         remainingQty -= batches[i].consumed_qty;
  //       }
  //     }
  //   }
  //   return batches;
  // }
  const getBatches = (inputBatches, quantity, allStock) => {
    let remainingQty = new Decimal(quantity);
    if (!inputBatches?.length) return [];
  
    const batches = JSON.parse(JSON.stringify(inputBatches?.filter((item) => item.is_usable)));
  
    for (let i = 0; i < batches?.length; i++) {
      batches[i].key = uuidv4();
      batches[i].consumed_qty = 0;
      batches[i].batch_in_use = true;
    }
  
    for (let i = 0; i < batches?.length; i++) {
      if (allStock && batches[i]?.is_rejected_batch) {
        batches[i].consumed_qty = 0;
       continue;
      }
      if (batches[i]?.batch_in_use) {
        const availableQty = new Decimal(batches[i]?.available_qty || 0);
        const consumedQty = new Decimal(batches[i]?.consumed_qty || 0);
  
        if (remainingQty.gt(0) && consumedQty.lt(availableQty)) {
          const qtyToConsume = Decimal.min(availableQty, remainingQty);
          batches[i].consumed_qty = qtyToConsume.toNumber();
          remainingQty = remainingQty.minus(qtyToConsume);
        } else {
          batches[i].consumed_qty = 0;
          remainingQty = remainingQty.minus(new Decimal(batches[i].consumed_qty));
        }
      }
    }
    return batches;
  };
  

  useEffect(() => {
    if (items?.length > 0) {
      setRawMaterials(items?.map((item) => {
        let requiredQuantity;
        let pendingQuantity;
        if(rmIssueType === 'RAW_MATERIAL') {
          requiredQuantity = item?.required_input_qty;
          pendingQuantity = (requiredQuantity - item?.total_issued_qty) > 0 ? (requiredQuantity - item?.total_issued_qty) : 0;
        } else {
          requiredQuantity = item?.required_processing_qty;
          pendingQuantity = item?.required_processing_qty - item?.wip_details?.total_qty_sent_for_processing;
        }
        const batches = getBatches(item?.product_batches, Math.min(pendingQuantity, Helpers.getValueTotalInObject(item?.product_batches, 'available_qty')), true);
        return {
          ...item,
          key: uuidv4(),
          required_quantity: requiredQuantity,
          quantity: pendingQuantity,
          pending_quantity: pendingQuantity,
          product_batches: Helpers.batchSelectionMethod('FIFO', batches, pendingQuantity, true),
          batchConsumptionMethod: Helpers.getBatchMethod(item?.product_batches),
          good_stock_only: true,
        }
      }))
    }
  }, [items]);

  /**
   *
   */
  const addRawMaterial = () => {
    if (!isDataValid()) return;
    if (rmIssueType === 'RAW_MATERIAL') {
      const rmAdjustments = [];
      rawMaterials?.map((rmLine) => {
        rmLine.product_batches?.filter((item) => item?.consumed_qty > 0)?.map((item) => {
          rmAdjustments.push({
            entity_type: 'RAW_MATERIAL',
            entity_id: rmLine?.mo_line_id,
            quantity: -item?.consumed_qty,
            mo_id: selectedJobWork?.mo_id,
            status: 'ISSUED',
            batch_id: item?.batch_id,
            cost_price: item?.cost_price,
            selling_price: item?.selling_price,
            lot_number: item?.lot_number || '',
            custom_batch_number: item?.batch_number,
            expiry_date: item?.expiry_date,
            wastage_quantity: 0,
            production_route_line_id: selectedJobWork?.production_route_line_id,
            prl_input_material_id: rmLine?.prl_input_material_id,
            reservation_id: item?.reservation_id,
            production_route_id: selectedJobWork?.production_route_id
          });
        });
      });
      if (rmAdjustments?.length) {
        createMOAdjustment({
          mo_adjustments: rmAdjustments,
        }, () => callback());
      }
    } else {
      const rmAdjustments = [];
      rawMaterials?.map((rmLine) => {
        rmLine.product_batches?.filter((item) => item?.consumed_qty > 0)?.map((item) => {
          rmAdjustments.push({
            batch_id: item?.batch_id,
            product_sku_id: rmLine?.product_sku_id,
            tenant_id: selectedJobWork?.tenant_id,
            prl_processing_material_id: rmLine?.prl_processing_material_id,
            initial_qty: item?.consumed_qty,
            mo_id: selectedJobWork?.mo_id,
            tenant_product_id: rmLine?.tenant_product_id,
            item_mo_line_id: rmLine?.mo_line_id,
            item_mo_fg_id: rmLine?.mo_fg_id,
            reservation_id:item?.reservation_id,
            production_route_id: selectedJobWork?.production_route_id
          });
        });
      });
      processJwMaterial({
        processing_materials: rmAdjustments,
      }, () => {
        callback();
      })
    }
  }

  const isDataValid = () => {
    let isDataValid = true;
    for (let i = 0; i < rawMaterials?.length; i++) {
      if (Number(rawMaterials[i]?.quantity) > Helpers.getValueTotalInObject(rawMaterials[i]?.product_batches, 'available_qty') || Number(rawMaterials[i]?.quantity) < 0) isDataValid = false;
    }
    if (!rawMaterials?.filter((item) => Number(item?.quantity) > 0)?.length) isDataValid = false;
    return isDataValid;
  }

  
  const toggleBatch = (batch, item) => {
    const rmLines = JSON.parse(JSON.stringify(rawMaterials));
    for (let i = 0; i < rmLines?.length; i++) {
      if (rmLines[i]?.key === item?.key) {
        const rowBatches = rmLines[i]?.product_batches;
        for (let j = 0; j < rowBatches?.length; j++) {
          if (rowBatches[j]?.key === batch?.key) {
            rowBatches[j].batch_in_use = !rowBatches[j]?.batch_in_use;
            rmLines[i].quantity = new Decimal(rmLines[i].quantity)
              .minus(new Decimal(rowBatches[j].consumed_qty))
              .toNumber();
            rmLines[i].wastage = new Decimal(0).toNumber();
            rowBatches[j].consumed_qty = new Decimal(0).toNumber();
          }
        }
        break;
      }
    }
    setRawMaterials(rmLines)
  }

  function updateBatchValue(key, value, label, batchId) {
    const copyData = JSON.parse(JSON.stringify(rawMaterials));
    const updatedData = copyData.map((obj) => {
      if (obj.key === key) {
        let productBatches = obj?.product_batches;
        productBatches = productBatches?.map((productBatch) => {
          if (productBatch.batch_id === batchId) {
            // Check if label is 'consumed_qty' and apply logic based on available_qty
            if (label === 'consumed_qty') {
              return {
                ...productBatch,
                [label]: value > productBatch?.available_qty ? productBatch?.available_qty : value,
              };
            }
            // For other labels, simply update with the provided value
            return {
              ...productBatch,
              [label]: value,
            };
          }
          return productBatch;
        });

        // let qty = productBatches.reduce((sum, batch) => sum + (Number(batch.consumed_qty) || 0), 0);
        const qty = productBatches.reduce(
          (sum, batch) => sum.plus(new Decimal(batch.consumed_qty || 0)),
          new Decimal(0)
        );
        return {
          ...obj,
          product_batches: productBatches,
          quantity: qty,
        };
      }
      return obj;
    });

    setRawMaterials(updatedData)
  } 

  return (
    <div>
      <div className="mg-top-10">
        <Table
          showHeader
          size="small"
          columns={rawMaterialColumns?.filter((item) => !item?.hidden)}
          dataSource={rawMaterials}
          pagination={false}
          rowClassName={(record) => (!record?.product_batches?.map((item) => item.available_qty > 0)?.length ? 'disabled-row' : '')}
          expandable={{
            rowExpandable: (record) => record?.product_batches?.map((item) => item.available_qty > 0)?.length,
            expandedRowRender: (record) => (
              <RawMaterialBatchSelector
                batches={record?.good_stock_only ? record?.product_batches.filter((item) => !item.is_rejected_batch) : record?.product_batches}
                batchMethod={record?.batchConsumptionMethod}
                uomInfo={record?.uom_info}
                itemsRow={record}
                onToggleBatch={(batch, productBatchesRow) => toggleBatch(batch, productBatchesRow)}
                allStock={record?.good_stock_only}
                updateAllStock={(value) => {
                  updateAllStock(value, record?.key, record?.quantity);
                }}
                updateBatchConsumptionMethod={(value) => {
                  const copyData = JSON.parse(JSON.stringify(rawMaterials));
                  const sortedData = copyData?.map((item) => {
                    let requiredQuantity;
                    let pendingQuantity;
                    if(rmIssueType === 'RAW_MATERIAL') {
                      requiredQuantity = item?.required_input_qty;
                      pendingQuantity = (requiredQuantity - item?.total_issued_qty) > 0 ? (requiredQuantity - item?.total_issued_qty) : 0;
                    } else {
                      requiredQuantity = item?.required_processing_qty;
                      pendingQuantity = item?.required_processing_qty - item?.wip_details?.total_qty_sent_for_processing;
                    }
                    if (record.key === item.key) {
                      item.batchConsumptionMethod = value;
                      item.product_batches = Helpers.batchSelectionMethod(value, getBatches(item?.product_batches, Math.min(pendingQuantity, Helpers.getValueTotalInObject(item?.product_batches, 'available_qty')), item?.good_stock_only), item?.required_input_qty ?? item?.required_processing_qty, record?.good_stock_only);
                    }
                    return {
                      ...item,
                    };
                  });
                  setRawMaterials(sortedData);
                }}
                updateBatchValue={(value, label, batchId) => updateBatchValue(record?.key, value, label, batchId)}
                hideSelectAllBatchesOption
              />
            ),
          }}
          scroll={{ x: true }}
          bordered
          loading={processJwMaterialLoading}
        />
      </div>
      <div className="custom-drawer__footer" style={{ width: '905px' }}>
        <Button
          type="primary"
          onClick={() => addRawMaterial()}
          loading={createMOAdjustmentLoading || processJwMaterialLoading}
          disabled={createMOAdjustmentLoading || processJwMaterialLoading}
        >
            Issue Stock
        </Button>
      </div>
    </div>
  );
}

const mapStateToProps = ({
  UserReducers, MOReducers, JobWorkReducers,
}) => ({
  user: UserReducers.user,
  createMOAdjustmentLoading: MOReducers.createMOAdjustmentLoading,
  processJwMaterialLoading: JobWorkReducers.processJwMaterialLoading,
});

const mapDispatchToProps = (dispatch) => ({
  createMOAdjustment: (payload, callback) => dispatch(MOActions.createMOAdjustment(payload, callback)),
  processJwMaterial: (payload, callback) => dispatch(jobWorkActions.processJwMaterial(payload, callback)),
});


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IssueRawMaterial));
